import { defineStore } from "pinia";
import { BlockGrant, useIdentityApi } from "@webapp/auth/IdentityApi"
import { AsyncData, LoadMode } from "@webapp/util/AsyncData"
import { DateTime } from "luxon"
import { AsyncDataStore } from "@/util/AsyncDataStore"

export const useIdentityBlockGrantStore = defineStore("identityBlockGrantStore", () => {
    const asyncBlockGrants = new Map<string, AsyncData<BlockGrant>>()

    const identityApi = useIdentityApi()

    function getAsyncBlockGrant(id: string | undefined, loadMode = LoadMode.TrackOnly) {
        const store = useIdentityBlockGrantStore() // use to get/return reactive store objects
        const loadAsync = async (ids: string[], requestTime: DateTime) => {
            const b = await identityApi.tryGetBlockGrantAsync(ids[0])
            console.log(`Loaded block grant ${id}`)
            return new Map([[ids[0], b]])
        }
        return AsyncDataStore.getAsyncItemsByIds(store.asyncBlockGrants, [id], "BlockGrant", loadMode, loadAsync).at(0)
    }

    async function getBlockGrantAsync(id: string | undefined) {
        const asyncData = getAsyncBlockGrant(id, LoadMode.EnsureLoaded)
        return await asyncData?.whenLoadCompleted
    }

    return {
        asyncBlockGrants,

        getAsyncBlockGrant,
        getBlockGrantAsync,
    }
})
